<template>
    <div>
        <a-modal
            :visible="visible"
            :title="$t('program.batch_add_program_modal.title' /* 批量添加论文日程 */)"
            :width="500"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item>
                    <input type="hidden" v-decorator="['session_id']" />
                </a-form-item>
                <a-form-item :label="$t('program.batch_add_program_modal.abstract_ids' /* 论文编号 */)">
                    <a-textarea
                        :placeholder="$t('program.batch_add_program_modal.please_input' /* 请输入 */)"
                        :rows="4"
                        v-decorator="['abstract_ids', { rules: [{ required: true, message: $t('program.batch_add_program_modal.please_input_abstract_ids' /* 请输入论文编号 */) }] }]"
                    />
                    <template slot="extra">
                        <span style="color: #f00">{{ $t('program.batch_add_program_modal.input_abstract_ids_tip' /* 请输入想要批量添加的论文编号，多条论文使用换行进行分隔 */) }}</span>
                    </template>
                </a-form-item>
                <a-form-item :label="$t('program.batch_add_program_modal.speaker_type' /* 讲题讲者类型 */)">
                    <a-radio-group v-decorator="['speaker-type', { rules: [{ required: true, message: $t('program.batch_add_program_modal.please_select_speaker_type' /* 请选择讲题讲者类型 */) }] }]">
                        <a-radio value="cn">{{ $t('program.batch_add_program_modal.speaker_type_cn' /* 中宾讲题讲者 */) }}</a-radio>
                        <a-radio value="en">{{ $t('program.batch_add_program_modal.speaker_type_en' /* 外宾讲题讲者 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="$t('program.batch_add_program_modal.minutes' /* 每段日程任务的分钟数 */)">
                    <a-input-number
                        style="width: 100%"
                        :placeholder="$t('program.batch_add_program_modal.reg' /* 例如：15 */)"
                        v-decorator="['minutes', { rules: [{ required: true, message: $t('program.batch_add_program_modal.please_input_minutes' /* 请输入每段日程任务的分钟数 */) }] }]"
                        :min="0"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'BatchAddProgramModal',
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        show(data) {
            this.visible = true;
            this.$nextTick(() => {
                this.form.setFieldsValue({ session_id: data.id });
            });
        },
        /**
         * 确定
         */
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$request
                        .post({ url: 'batchAddAbstract', data: values })
                        .then(res => {
                            this.$message.success(this.$t('program.batch_add_program_modal.add_success' /* 添加成功 */));
                            this.$emit('refresh');
                            this.form.resetFields();
                            this.visible = false;
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        /**
         * 取消
         */
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    }
};
</script>
<style lang="less" scoped>
</style>